<template>
  <transition name="fade">
    <button v-if="!active" class="ai-practice-toggle-mobile" @click="togglePractice">
      <i class="fas fa-robot"></i>
      <span class="toggle-text">프롬프트 실습</span>
    </button>
  </transition>
</template>

<script>
export default {
  name: 'LLMPracticeToggleMobile',
  emits: ['toggle'],
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const togglePractice = () => {
      emit('toggle', !props.active);
    }
    return {
      togglePractice
    };
  }
}
</script>

<style scoped>
.ai-practice-toggle-mobile {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 20px;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1000;
  animation: pulse 1.2s infinite;
  position: relative;
}
.ai-practice-toggle-mobile:hover {
  background: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}
.ai-practice-toggle-mobile i {
  font-size: 16px;
}
.toggle-text {
  font-weight: 500;
}

@keyframes pulse {
  0% { box-shadow: 0 0 16px 4px #6366f1, 0 0 32px 8px #a5b4fc; }
  50% { box-shadow: 0 0 32px 12px #a5b4fc, 0 0 48px 16px #6366f1; }
  100% { box-shadow: 0 0 16px 4px #6366f1, 0 0 32px 8px #a5b4fc; }
}


@media (max-width: 480px) {
  .ai-practice-toggle-mobile {
    bottom: 70px;
    right: 16px;
    padding: 10px 16px;
    font-size: 13px;
  }
}
/* Fade transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>